import { render, staticRenderFns } from "./RiskCompleted.vue?vue&type=template&id=12819760"
import script from "./RiskCompleted.vue?vue&type=script&lang=js"
export * from "./RiskCompleted.vue?vue&type=script&lang=js"
import style0 from "./RiskCompleted.vue?vue&type=style&index=0&id=12819760&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports